import * as Types from '../../types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type CreateApiKeyMutationVariables = Types.Exact<{
  input: Types.CreateApiKeyInput;
}>;

export type CreateApiKeyMutation = {
  __typename?: 'Mutation';
  createApiKey: {
    __typename?: 'CreateApiKeyPayload';
    keyId: any;
    plaintextKey: string;
    apiKey: {
      __typename?: 'ApiKey';
      id: any;
      label: string;
      keyType: Types.ApiKeyType;
      createdAt: any;
      lastUsedAt?: any | null;
      userId?: any | null;
      teamId?: any | null;
    };
  };
};

export const CreateApiKeyDocument = gql`
  mutation CreateApiKey($input: CreateApiKeyInput!) {
    createApiKey(input: $input) {
      keyId
      plaintextKey
      apiKey {
        id
        label
        keyType
        createdAt
        lastUsedAt
        userId
        teamId
      }
    }
  }
`;
export type CreateApiKeyMutationFn = Apollo.MutationFunction<
  CreateApiKeyMutation,
  CreateApiKeyMutationVariables
>;

/**
 * __useCreateApiKeyMutation__
 *
 * To run a mutation, you first call `useCreateApiKeyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateApiKeyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createApiKeyMutation, { data, loading, error }] = useCreateApiKeyMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateApiKeyMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateApiKeyMutation,
    CreateApiKeyMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateApiKeyMutation,
    CreateApiKeyMutationVariables
  >(CreateApiKeyDocument, options);
}
export type CreateApiKeyMutationHookResult = ReturnType<
  typeof useCreateApiKeyMutation
>;
export type CreateApiKeyMutationResult =
  Apollo.MutationResult<CreateApiKeyMutation>;
export type CreateApiKeyMutationOptions = Apollo.BaseMutationOptions<
  CreateApiKeyMutation,
  CreateApiKeyMutationVariables
>;
